<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="p1"></a><a id="p2"></a><a id="p3"></a><a id="p4"></a><a id="p5"></a><a id="p6"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2006<br/>
Copyright © 1992 by Paul Theroux</p>
<p class="center spaceabove1"><span class="smallcaps">ALL RIGHTS RESERVED</span></p>
<p class="center spaceabove1">All rights reserved. For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>The Library of Congress has cataloged the print edition as follows:</em></p>
<p class="center ">Theroux, Paul.<br/>
The happy isles of Oceania : paddling the Pacific / Paul<br/>
Theroux.—1st Mariner Books ed.<br/>
p. cm.</p>
<p class="center ">Originally published: New York : G.P. Putnam’s Sons, <span class="smallcaps">C</span>1992.<br/>
<span class="smallcaps">ISBN</span>-13: 978-0-618-65898-5 (pbk.)<br/>
<span class="smallcaps">ISBN-</span>10: 0-618-65898-x (pbk.)<br/>
1. Oceania—Description and travel. 2. Oceania—History,<br/>
Local. 3. Theroux, Paul—Travel—Oceania. 4. Sea<br/>
kayaking—Oceania. 1. Title.<br/>
<span class="smallcaps">DU</span>23.5.<span class="smallcaps">T</span>47 2006 919.504—dc22<br/>
2006028742</p>
<p class="center spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-52518-1<br/>
v3.0920</p>
<p class="center spaceabove1">The author gratefully acknowledges permission from Faber and Faber Ltd. for the lines from “Brother Fire” by Louis MacNeice. Reprinted from <em>The Collected</em> <em>Poems of Louis MacNeice.</em></p>
<p class="center spaceabove1">Maps by Lisa Amoroso.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?784655a9